import React from "react"
import {
	// DashboardOutlined,
	FileTextOutlined,
	SearchOutlined,
	PlayCircleOutlined,
	LockOutlined,
} from "@ant-design/icons"

import LogDisplay from "./Pages/LogDisplay"
import MailLog from "./Pages/MailLog"
import SpecificMailLog from "./Pages/SpecificMailLog"
import ManageStockist from "./Pages/ManageStockist"
import UploadAndMapStockist from "./Pages/UploadAndMapStockists"
import AllClientApiRun from "./Pages/AllClientApiRun"
import MD5Hasher from "./Pages/MD5Hasher"

const routes = [
	{
		icon: <SearchOutlined />,
		title: "Search Mail Log",
		path: "/",
		component: MailLog,
		availableToUserTypes: [10, 30],
		props: {},
	},
	{
		icon: <SearchOutlined />,
		title: "Search Critical Stockist Files",
		path: "/critical-stockists",
		component: SpecificMailLog,
		availableToUserTypes: [10, 30],
		props: {},
	},
	{
		icon: <FileTextOutlined />,
		title: "Show Server Logs",
		path: "/logs",
		component: LogDisplay,
		availableToUserTypes: [10],
		props: {},
	},
	{
		icon: <FileTextOutlined />,
		title: "Add Stockist Entry",
		path: "/add-stockist",
		component: ManageStockist,
		availableToUserTypes: [10],
		props: {},
	},
	{
		icon: <FileTextOutlined />,
		title: "Bulk Map Stockists",
		path: "/upload-and-map-stockists",
		component: UploadAndMapStockist,
		availableToUserTypes: [10],
		props: {},
	},
	{
		icon: <PlayCircleOutlined />,
		title: "All Client API Run",
		path: "/all-client-api-run",
		component: AllClientApiRun,
		availableToUserTypes: [10],
		props: {},
	},
	{
		icon: <LockOutlined />,
		title: "MD5 Hasher",
		path: "/md5-hasher",
		component: MD5Hasher,
		availableToUserTypes: [10, 30],
		props: {},
	},
]

export default routes
